/* eslint-disable max-len */
<template>
  <div>
    <table class="ui striped selectable table">
      <thead>
        <tr>
          <th>Classification</th>
          <th>Meaning</th>
          <th>Explanation</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!category || category === 'L'" style="vertical-align: top">
          <td><span class="ui purple label">L</span></td>
          <td>Social Acceptance - ‘Liked’ Students</td>
          <td>
            <!-- eslint-disable-next-line max-len -->
            A significant number of peers nominated them for ‘like most’ to work
            with. Some of these high status students can be called upon to
            improve the class culture. However examination of their ‘likes’ and
            ‘rejects’ should be explored first.
          </td>
        </tr>
        <tr v-if="!category || category === 'UN'" style="vertical-align: top">
          <td><span class="ui grey label">UN</span></td>
          <td>Inclusion Need - Unchosen Students</td>
          <td>
            <!-- eslint-disable-next-line max-len -->
            No ‘like most’ nominations received and typically they receive many
            ‘like least’. These students are the most vulnerable and most in
            need of help and support. It is usually best to begin with these.
          </td>
        </tr>
        <tr v-if="!category || category === 'R'">
          <td><span class="ui yellow label">R</span></td>
          <td>Inclusion Opportunity - ‘Rejected’ Students</td>
          <td>
            <!-- eslint-disable-next-line max-len -->
            A significant number of ‘like least’ to work with nominations
            received. Pay attention to social impact (SI) and social preference
            (SP) of students in this category.
          </td>
        </tr>
        <tr v-if="!category || category === 'N'" style="vertical-align: top">
          <td><span class="ui green label">N</span></td>
          <td>Integration Opportunity - ‘Neglected’ Students</td>
          <td>
            <!-- eslint-disable-next-line max-len -->
            A significant of ‘don’t mind’ nominations are received with fewer
            ‘like most’ or ‘like least’ nominations.
          </td>
        </tr>
        <tr v-if="!category || category === 'C'" style="vertical-align: top">
          <td><span class="ui teal label">C</span></td>
          <td>Cohesion Needed - ‘Controversial’ Students</td>
          <td>
            <!-- eslint-disable-next-line max-len -->
            A significant number of ‘like most’ and a significant number of
            ‘like least’ nominations received. These students elicit a strong
            response from their peers.
          </td>
        </tr>
        <tr v-if="!category || category === 'A'">
          <td><span class="ui brown label">A</span></td>
          <td>Average</td>
          <td>
            <!-- eslint-disable-next-line max-len -->
            These students receive nominations closer to the mean˟ for ‘like
            most’, ‘don’t mind’ and ‘like least’ nominations
          </td>
        </tr>
        <tr v-if="!category || category === 'UC'" style="vertical-align: top">
          <td><span class="ui blue label">UC</span></td>
          <td>Unclassified Students</td>
          <td>
            <!-- eslint-disable-next-line max-len -->
            These students do not reach the statistical cut off points for any
            of the above classifications
          </td>
        </tr>
        <tr v-if="!category || category === '1LR'" style="vertical-align: top">
          <td><span class="ui grey label">1LR</span></td>
          <td>1 like received</td>
          <td>
            <!-- eslint-disable-next-line max-len -->
            Statistically these students are almost as vulnerable as those who
            are entirely unchosen so treat as above.
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="!category">
      <p>
        * ZSP score greater than 1 AND ZR score less than 0 AND ZL score greater
        than 0
      </p>
      <!-- eslint-disable-next-line max-len -->
      <p>
        [SP (social preference) = number of ‘like most’ nominations minus number
        of ‘like least’ nominations standardised by class (Z scores)
      </p>
      <p>ZR – Standardised rejects (like least)</p>
      <p>ZL – Standardised likes (like most)]</p>
      <p>
        # ZSP score less than -1 AND ZR score greater than 0 AND ZL scoreless
        than 0
      </p>
      <p>
        § ZSI score less than -1 AND ZL score less than 0 AND ZR score less than
        0
      </p>
      <!-- eslint-disable-next-line max-len -->
      <p>
        [SI (social Impact) = number of ‘like most’ nominations plus number of
        ‘like least’ nominations standardised by class (Z scores)]
      </p>
      <!-- eslint-disable-next-line max-len -->
      <p>
        ¤ ZSI score greater than 1 AND ZL score greater than 0 AND ZR score
        greater than 0
      </p>
      <p>˟ ZSI AND ZSP scores are BOTH between -0.5 and +0.5.</p>
    </div>
    <div v-if="category === '1LR'">
      <p>
        Some unchosen students mutually ‘like’ each other to save themselves
        from being entirely unchosen. School is likely to be a very unhappy
        place for these students.
      </p>
      <table class="ui celled table">
        <tbody>
          <tr>
            <td style="vertical-align: top">
              Unchosen, highly rejected but many likes for others
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>Reaching out for social inclusion</li>
                <li>Has no close relationships.</li>
                <li>School probably not a happy or safe place</li>
              </ul>
            </td>
            <td style="vertical-align: top" rowspan="3">
              <ul style="margin: 0px">
                <li>
                  Look at profile of students whom these students reject. They
                  may fear a powerful or controversial student or may have
                  already been targeted by them
                </li>
                <li>
                  Conduct empathic interviews with this student to get deeper
                  insight into their experience
                </li>
                <li>
                  Teachers may give attention to teams containing these students
                  to boost their self-esteem
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: top">
              Unchosen, highly rejected & rejects many
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>Very vulnerable</li>
                <li>Likes no one and no one likes them</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: top">
              Unchosen, rejected & many ‘don’t minds’
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>Poorly integrated & vulnerable</li>
                <li>Likely playing it safe with ‘don’t mind’</li>
                <li>
                  Still seeking inclusion but without much enthusiasm or hope
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="category === 'UC'">
      <table class="ui celled table">
        <tbody>
          <tr>
            <td style="vertical-align: top">
              The statistical cut-off points for any of the above
              classifications have not been reached.
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>
                  These students are not a homogenous group. They are close to
                  one of their extreme peer categories (L,R,N,C).
                </li>
                <li>
                  They display the characteristics of the categories they are
                  close to.
                </li>
              </ul>
            </td>
            <td style="vertical-align: top" rowspan="3">
              <ul style="margin: 0px">
                <li>
                  Look to their SP and SI scores to find which category they are
                  close to
                </li>
                <li>
                  Look at the guidelines for whichever group they are closest
                  to.
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        Look to their SP and SI scores to see which group that may be. As above,
        give further consideration to their give ‘likes’ and ‘rejects’ and their
        mutual ‘likes’ and ‘rejects’.
      </p>
    </div>
    <div v-if="category === 'A'">
      <table class="ui celled table">
        <tbody>
          <tr>
            <td style="vertical-align: top">
              This students receive nominations closer to the mean of ‘like’,
              ‘don’t mind’ and ‘like least’
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>
                  these students don’t tend to be targeted for whole class
                  exclusion
                </li>
                <li>
                  may have individual positive or negative relationships with
                  peers
                </li>
              </ul>
            </td>
            <td style="vertical-align: top" rowspan="3">
              <ul style="margin: 0px">
                <li>
                  Examine the nominations they have cast for any mutual ‘likes’
                  or ‘rejects’
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="category === 'N'">
      <table class="ui celled table">
        <tbody>
          <tr>
            <td style="vertical-align: top">Neglected, low SP and SI</td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>
                  These students do not tend to be targeted for rejection but
                  may lack close friendships and may not be well integrated in
                  class
                </li>
                <li>
                  They can be vulnerable and in need of support and integration
                  opportunities
                </li>
              </ul>
            </td>
            <td style="vertical-align: top" rowspan="3">
              <ul style="margin: 0px">
                <li>
                  Further examination of their given ‘likes’ and ‘rejects’
                  should be done to explore where integration opportunities may
                  exist for them within the class.
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="category === 'L'">
      <p>
        High status students who are highly rejecting of their peers are not
        necessarily recommended as empathic interview candidates in the initial
        stages.
      </p>
      <table class="ui celled table">
        <tbody>
          <tr>
            <td style="vertical-align: top">
              ‘liked’ by many and gives few ‘reject’ nominations
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>
                  Has power in the class and could be a positive influence.
                </li>
                <li>Can be called upon to help improve class culture</li>
              </ul>
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>
                  Empathic interviews with these students could help provide
                  further insight into class dynamics
                </li>
                <li>
                  Their potential could be harnessed by providing them with
                  leadership opportunities in class.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: top">
              ‘liked’ by many, gives few ‘rejects’ but low SI score (negative
              number
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>
                  Despite being well liked these students are not very impactful
                </li>
              </ul>
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>
                  Give leadership opportunities to boost esteem, develop
                  leadership skills and accentuate the positive influence of
                  these students
                </li>
                <li>
                  empathic interviews with these students could provide further
                  insight into improving class dynamics
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: top">
              ‘liked’ by many but gives many ‘reject’ nominations
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>
                  Holds power in the class but may not be using it in a positive
                  way
                </li>
                <li>Possible disruptive influence in class</li>
              </ul>
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>
                  Remove inappropriate power from these students by directing
                  focus onto to those who can provide positive leadership
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: top">
              ‘liked’ but no mutual like<br /><i>This is very rare.</i>
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>
                  Although liked these students may not be very well integrated
                </li>
              </ul>
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>Provide student with integration opportunities.</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="category === 'R'">
      <p>
        <b
          >Guidelines for ‘unchosen’ students should also be applied where
          appropriate for this group in addition to points made in the table
          below.</b
        >
      </p>
      <table class="ui celled table">
        <tbody>
          <tr>
            <td style="vertical-align: top">Rejected, low SI and low SP</td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>Not impactful and likely to be poorly integrated</li>
                <li>
                  Rejected students may come together to support each other thus
                  making it difficult for teachers to identify their rejected
                  status
                </li>
              </ul>
            </td>
            <td style="vertical-align: top" rowspan="2">
              <ul style="margin: 0px">
                <li>
                  Teachers may give attention to teams containing these students
                  to boost their self-esteem
                </li>
                <li>
                  Perhaps show an interest in their extra-curricular activities
                  that they may do well in
                </li>
                <li>
                  This must be co-ordinated so not all teachers do it at once,
                  making it obvious.
                </li>
                <li>
                  Conduct empathic interviews with this student to get deeper
                  insight into their experience
                </li>
                <li>
                  Teamwork in class can allow other teams to work and receive
                  positive recognition without drawing individual attention.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: top">Rejected, high SI and low SP</td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>These students elicit strong negative emotions</li>
                <li>Impactful in class</li>
                <li>Could be a disruptive influence in class</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="category === 'UN'">
      <table class="ui celled table">
        <tbody>
          <tr>
            <td style="vertical-align: top">
              Unchosen, highly rejected but many likes for others
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>Reaching out for social inclusion</li>
                <li>Has no close relationships.</li>
                <li>School probably not a happy or safe place</li>
              </ul>
            </td>
            <td style="vertical-align: top" rowspan="3">
              <ul style="margin: 0px">
                <li>
                  Look at profile of students whom these students reject. They
                  may fear a powerful or controversial student or may have
                  already been targeted by them
                </li>
                <li>
                  Conduct empathic interviews with this student to get deeper
                  insight into their experience
                </li>
                <li>
                  Teachers may give attention to teams containing these students
                  to boost their self-esteem
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: top">
              Unchosen, highly rejected & rejects many
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>Very vulnerable</li>
                <li>Likes no one and no one likes them</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: top">
              Unchosen, rejected & many ‘don’t minds’
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>Poorly integrated & vulnerable</li>
                <li>Likely playing it safe with ‘don’t mind’</li>
                <li>
                  Still seeking inclusion but without much enthusiasm or hope
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="category === 'C'">
      <p>
        These students divide the class and can frequently be a disruptive
        influence. The level of this impact is reflected in their SI score.
      </p>
      <table class="ui celled table">
        <tbody>
          <tr>
            <td style="vertical-align: top">Controversial and high SI</td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>
                  These students may have considerable, disruptive influence in
                  the class
                </li>
                <li>
                  Sometimes the students themselves are not disruptive but the
                  class are divided in response to them.
                </li>
              </ul>
            </td>
            <td style="vertical-align: top">
              <ul style="margin: 0px">
                <li>
                  ‘likes’ and ‘rejects’ given by these students should be
                  examined
                </li>
                <li>
                  Information from empathic interviews with ‘liked’ and
                  ‘rejected’ students could give more insight into these
                  students.
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClassificationsLegendContent',
  props: ['category'],
  data() {
    return {};
  },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/tests/ClassificationsLegendContent.vue